import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import createMutationsSharer from 'vuex-shared-mutations'
import mutations from './mutations'
import actions from './actions'
import application from './modules/application'
import notifications from './modules/notifications'
import user from './modules/user'
import ovb from './modules/ovb'
import hlp from './modules/hlp'
import brochure from './modules/brochure'
import billing from './modules/billing'
import projects from './modules/projects'
import activitiesBrowsers from './modules/activitiesBrowsers'
import worksheetsBrowsers from './modules/worksheetsBrowsers'
import videosBrowsers from './modules/videosBrowsers'
import tours from './modules/tours'
import app from './modules/app'
import apolloErrors from './modules/apolloErrors'
import helpLinks from './modules/helpLinks'
import clinicInfo from '@/store/modules/clinicInfo'
Vue.use(Vuex)

// Safe VuexPersistence — if localStorage has corrupt/stale data, clear it instead of crashing
const vuexLocal = new VuexPersistence({
  storage: {
    getItem (key) {
      try {
        const raw = window.localStorage.getItem(key)
        if (raw) JSON.parse(raw) // test parse
        return raw
      } catch (e) {
        console.warn('[VuexPersistence] Corrupt localStorage, clearing:', e.message)
        window.localStorage.removeItem(key)
        return null
      }
    },
    setItem (key, value) {
      // Strip globalLoading before persisting — never save overlay state to localStorage
      try {
        const parsed = JSON.parse(value)
        if (parsed && parsed.application) {
          parsed.application.globalLoading = { show: false, message: '' }
        }
        window.localStorage.setItem(key, JSON.stringify(parsed))
      } catch (e) {
        window.localStorage.setItem(key, value)
      }
    },
    removeItem (key) { window.localStorage.removeItem(key) },
    get length () { return window.localStorage.length },
    key (index) { return window.localStorage.key(index) },
    clear () { window.localStorage.clear() }
  }
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    refresh: false
  },
  mutations: mutations,
  actions: actions,
  modules: {
    application,
    clinicInfo,
    user,
    app,
    ovb,
    hlp,
    billing,
    projects,
    brochure,
    notifications,
    activitiesBrowsers,
    worksheetsBrowsers,
    videosBrowsers,
    tours,
    helpLinks,
    apolloErrors
  },
  plugins: [
    vuexLocal.plugin,
    createMutationsSharer({ predicate: ['ovb/SET_DEMO_SESSION', 'ovb/SET_CURRENT_ACTIVITY_EXPLORER_CONFIGURATION'] })
  ]
})
